import { useEffect, useState } from 'react';
import type { VersionInfo } from '@app/shared';
import { getVersion } from '../api';

// Fetches from the API rather than baking version into the client build, so what's
// displayed always reflects what's actually deployed on the backend — even if only
// the API (not the client) was redeployed.
export function VersionFooter() {
  const [info, setInfo] = useState<VersionInfo | null>(null);

  useEffect(() => {
    getVersion().then(setInfo).catch(() => setInfo(null));
  }, []);

  if (!info) return null;

  return (
    <footer className="app-footer">
      <span title={`Built ${info.buildNumber} · deployed ${info.deployedAt ?? 'unknown'}`}>
        {info.environment} · v{info.version} · {info.commitSha.slice(0, 7)}
      </span>
    </footer>
  );
}
